import fetch from 'utils/request';
import { sift_query_list } from 'utils/sift';

// ! 获取基础配置
export function apiGetApp(data){
    // return axios.all([apiGetSubBrandList(), apiPostChannelList(data),apiGetSkillGroupLists(data)])
	return axios.all([apiGetSubBrandList(), apiPostChannelList(data)])
}

// ! 子品牌
export function apiGetSubBrandList() {
	return fetch({
        url: '/ocs-auth/brand/manage/logon/subBrand',
        method: 'get'
    });
}

// ! 渠道
export function apiPostChannelList(data) {
	return fetch({
        url: '/ocs-project/project/channel/list.json',
        method: 'post',
        data: sift_query_list({brandIdentify: data.brandIdentify, channelStatus: '0'}),
		contentType: 'formData'
    });
}

// ! 技能组
export function apiGetSkillGroupLists(data){
	return fetch({
		url:`/livechat/skillGroup/list/${data.brandIdentify}`,
		method: 'get'
	})
}

// ! 下载zip
export function apiGetFiles(data){
	return fetch({
		url:`/ocs-file/getFiles`,
		method: 'post',
		data: data,
		responseType: 'blob'
	})
}

// ! 日志
export function apiPostOcsWebLog(data){
	return fetch({
		url:`/ocs-weblog/log/add`,
		method: 'post',
		data: data,
	})
}
